import { footerColumns } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.4fr_2fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 font-heading text-lg font-bold text-primary-950">
                料
              </span>
              <span className="font-heading text-xl font-bold">黑料视频</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200/80">
              把今天刚出、正在热传的更新集中到一处，不用到处翻新鲜瓜。刷屏内容一出现就补，方便随时回看刚出的视频和当场动向。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="rounded-full bg-primary-800 px-3 py-1 text-xs text-background-200">
                今日更新 128 条
              </span>
              <span className="rounded-full bg-primary-800 px-3 py-1 text-xs text-background-200">
                热传中 36 条
              </span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            {footerColumns.map((column) => (
              <div key={column.title}>
                <h4 className="font-heading text-sm font-semibold text-background-100">
                  {column.title}
                </h4>
                <ul className="mt-4 space-y-2.5">
                  {column.links.map((link) => (
                    <li key={link}>
                      <a
                        href="#top"
                        className="text-sm text-background-200/75 transition-colors hover:text-accent-400"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-background-200/60 sm:flex-row sm:items-center sm:justify-between">
          <p>本站内容为聚合展示与演示用途，相关素材仅作浏览参考。</p>
          <p>© 2026 黑料视频 · 聚合最新热传更新</p>
        </div>
      </div>
    </footer>
  );
}